import React from 'react';

export function StepIdentificatorsLabel() {
  return (
    <>
      Nová provozovna - <b>Klasifikace, Identifikátory</b>
    </>
  );
}
